import colors from '../colors';

export default {
  container: {
    height: 10,
    borderRadius: 10,
  },
  progressBarContainer: {
    width: '100%',
    backgroundColor: colors.lightGray,
    boxShadow: 'inset 0 .1rem .3rem rgba(0,0,0,0.12)',
  },
  progressBar: {
    background: `linear-gradient(${colors.mainLight}, ${colors.main})`,
    transition: 'width .28s ease-out',
  },
  pagination: {
    float: 'right',
    marginRight: 5,
    marginTop: 15,
    fontSize: 13
  }
};
